export default __webpack_public_path__ + "static/media/arrow_up.1dd51a8d.svg";